module.exports = __webpack_public_path__ + "static/media/lease2_img9.edcb7624.jpg";